import ReactGA from 'react-ga'

ReactGA.initialize('UA-112044218-9')

export default ReactGA
